const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const selectPrize = (prizes) => {
  const active = prizes.filter(p => p.active !== false);
  const totalWeight = active.reduce((s, p) => s + (p.weight || 0), 0);
  if (totalWeight === 0 || active.length === 0) return null;
  const r = Math.random() * totalWeight;
  let cum = 0;
  for (const p of active) {
    cum += p.weight || 0;
    if (r < cum) return p;
  }
  return active[active.length - 1];
};

export const recordWin = async (clientId, prizeId, prizeLabel) => {
  try {
    const res = await fetch(`${API}/roue/spin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ client_id: clientId, prize_id: prizeId, prize_label: prizeLabel }),
    });
    return await res.json();
  } catch {
    return { win: false };
  }
};
